export enum RecommendationTrackingContext {
  DEFAULT = 'default',
  BASKET = 'bkt',
  FREQUENTLY_BOUGHT_TOGETHER = 'fbt',
  PERSONALISED = 'pers',
  REVIEW = 'review',
  POST_ADD_TO_BASKET = 'postAddToBasket',
}

export enum RecommendationPageCategoryTracking {
  BASKET = 'Basket',
}
